import { IntroductionButton } from '@Components/IconButton';
import Introduction from '@Components/Introduction';
import { useDisclosure } from '@hooks/useDisclosure';
import { Box } from '@mui/material';
import { createPortal } from 'react-dom';
import { useWatch } from 'react-hook-form';
import { useGreenhouseForm } from '../EsgGreenhouseFormProvider';
import { IPerformanceGhGasMgmtReportFormValues } from '../EsgGreenhouseFormProvider/types';

export const GH_GAS_MGMT_REPORT_INTRODUCTION_ID =
  'gh-gas-mgmt-report-introduction';

const GreenhouseGasMgmtReportIntroduction = () => {
  const { control, getValues } = useGreenhouseForm();

  const { introduction } =
    getValues('performanceGhGasMgmtReport') ??
    ({} as IPerformanceGhGasMgmtReportFormValues);

  const [isIntroductionOpen, { open, close }] = useDisclosure(!!introduction);

  const ghGasMgmtReportIntroductionEl = document.getElementById(
    GH_GAS_MGMT_REPORT_INTRODUCTION_ID
  );

  const { completedSection } =
    useWatch({
      name: 'performanceGhGasMgmtReport',
      control,
    }) ?? ({} as IPerformanceGhGasMgmtReportFormValues);

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  return (
    <>
      <IntroductionButton
        onClick={open}
        disabled={isCompletedTh && isCompletedEn}
      />
      {isIntroductionOpen &&
        ghGasMgmtReportIntroductionEl &&
        createPortal(
          <Box mt={2}>
            <Introduction
              onDelete={close}
              topic="การรายงานผลการดำเนินงานและผลลัพธ์การจัดการก๊าซเรือนกระจก"
              setOpen={open}
              fieldPath="performanceGhGasMgmtReport.introduction"
              isCompletedEn={isCompletedEn}
              isCompletedTh={isCompletedTh}
            />
          </Box>,
          ghGasMgmtReportIntroductionEl
        )}
    </>
  );
};

export default GreenhouseGasMgmtReportIntroduction;
